// Chakra imports
import {Button, Flex, HStack, Image, Link, Spacer, Text, useColorModeValue} from "@chakra-ui/react";
import {ChatIcon} from '@chakra-ui/icons'
import {NavLink as ReactLink} from 'react-router-dom';
// Custom components
import Card from "components/card/Card.js";
// Custom icons
import React from "react";

function ProductNonMemoized(props) {
    const {image, name, ratings, review_count, key_, addToCompare} = props;
    const textColor = useColorModeValue("navy.700", "white");
    //console.log("ratings", ratings);
    return (
        <Card p='20px' maxWidth="350px">
            <Flex direction="column" grow={1}>
                <Image
                    src={image}
                    // w={{base: "100%", "2xl": "188px", "3xl": "100%"}}
                    // h={{base: "100%", "2xl": "178px", "3xl": "100%"}}
                    w='100%'
                    objectFit='contain'
                    borderRadius='10px'
                    me='15px'
                    mb={{base: "30px", "2xl": "0px"}}
                    sx={{aspectRatio: "1"}}
                />
                <Flex
                    flexDirection='column'
                    h='100%'
                    align={{base: "center", "2xl": "start"}}
                >
                    <Flex mb='25px' align='center'>
                        <Text
                            color={textColor}
                            fontWeight='bold'
                            fontSize={{
                                base: "16px",
                                md: "16px",
                                lg: "21px",
                                xl: "lg",
                                "2xl": "21px",
                            }}
                            noOfLines={[3, 4]}>
                            {name}
                        </Text>

                    </Flex>
                    <Flex
                        mb='30px'
                        flexWrap='wrap'
                        direction="column"
                        justify={{
                            base: "center",
                            md: "start",
                            lg: "center",
                            xl: "start",
                        }}
                        align={{
                            base: "center",
                            md: "start",
                            lg: "center",
                            xl: "start",
                        }}>
                        {
                            <Flex align='center' me={{base: "8px", lg: "16px"}} key={key_}>
                                <Text>{Object.keys(ratings).length}
                                    {(Object.keys(ratings).length > 1 ? " variants" : " variant")}
                                </Text>&nbsp;
                                <ChatIcon/><Text>{review_count}</Text>
                            </Flex>

                        }

                    </Flex>
                    <Spacer/>
                    <HStack mx="auto">
                        <Link to={`/home/products/analyze?product_family=${key_}`} as={ReactLink}
                              w={{base: "100%", "2xl": "100%"}}>
                            <Button
                                w={{base: "100%", "2xl": "100%"}}
                                h='40px'
                                color='navy.700'
                                fontSize='sm'
                                fontWeight='500'
                                border='1px solid'
                                borderColor='gray.200'
                                bg='transparent'
                                _hover={{bg: "gray.100"}}
                                _active={{bg: "transparent"}}
                                _focus={{bg: "transparent"}}
                                borderRadius='16px'
                                alignSelf={'flex-end'}
                            >
                                Analyze
                            </Button>
                        </Link>
                        <Button
                            w={{base: "100%", "2xl": "100%"}}
                            h='40px'
                            color='navy.700'
                            fontSize='sm'
                            fontWeight='500'
                            border='1px solid'
                            borderColor='gray.200'
                            bg='transparent'
                            _hover={{bg: "gray.100"}}
                            _active={{bg: "transparent"}}
                            _focus={{bg: "transparent"}}
                            borderRadius='16px'
                            alignSelf={'flex-end'}
                            onClick={(e) => addToCompare({imageHref: image, productIds: key_, productFamily: name})}>
                            Compare
                        </Button>
                    </HStack>

                </Flex>
            </Flex>
        </Card>
    );
}

export default React.memo(ProductNonMemoized)